export enum ClaimTableStatus {
  SUBMITTED = 'submitted',
  READY = 'ready',
  REVIEW = 'review',
  NO_ATTACHMENT = 'no-attachment',
}
